/** O que o Tab alcança dentro do painel. */
export const FOCUSABLE_SELECTOR = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[contenteditable='true']",
].join(",");

/**
 * Para onde o Tab tem de ir à força, ou `null` quando o navegador pode seguir
 * sozinho. `-1` é o próprio painel: sem nada focável, o foco fica nele.
 * `current` é o índice do elemento focado na lista do painel (`-1` = fora).
 */
export function trappedFocusIndex(
  current: number,
  total: number,
  backwards: boolean,
): number | null {
  if (total === 0) return -1;
  if (current === -1) return backwards ? total - 1 : 0;
  if (backwards && current === 0) return total - 1;
  if (!backwards && current === total - 1) return 0;
  return null;
}
